// Nome amigável de cada tela (para o histórico de acessos). Gerado a partir do menu lateral (Sidebar.js).
export const NOMES_TELAS = {
  '/abrir-chamado': 'Abrir Chamado',
  '/admin-eventos': 'Eventos',
  '/agenda-captacao': 'Agenda Enf. Captação',
  '/agenda-direcao': 'Agenda Direção',
  '/agenda-homecare': 'Agenda Homecare',
  '/agenda-qualidade': 'Agenda da Qualidade',
  '/analysis': 'Dashboard Projeto IW',
  '/app': 'Projeto IW',
  '/audit': 'Auditoria',
  '/chamado': 'Chamado',
  '/change-password': 'Trocar senha',
  '/controle-dispositivos': 'Dispositivos',
  '/convites': 'Convites de Agenda',
  '/cronograma-iw': 'Cronograma IW',
  '/dashboard-feridas': 'Dashboard Feridas',
  '/dashboard-hospitalizacao': 'Dashboard Hospitalização',
  '/dashboard-hub': 'Dashboard Hub',
  '/dashboard-implantacao': 'Dashboard Captação',
  '/dashboard-indicadores': 'Censo Homecare',
  '/dashboard-planilha': 'Dashboard Telefonia',
  '/dashboard-prontuario': 'Dashboard Prontuários',
  '/dashboard-visitas': 'Acomp. Visitas Domiciliares',
  '/email': 'E-mail',
  '/envio-carefy': 'Envio ao Carefy',
  '/escalas': 'Escalas Técnicos',
  '/formulario-passagem': 'Form. Passagem Téc. Educação',
  '/gestao-captacao': 'Gestão Captação',
  '/gestao-contas-enviadas': 'Envio de Contas',
  '/gestao-controladoria': 'Controle de Notas',
  '/gestao-feridas': 'Gestão de Feridas',
  '/gestao-logistica': 'Gestão da Logística',
  '/gestao-monitoramento-clinico': 'Monitoramento Clínico',
  '/gestao-ocorrencias': 'Gestão Ocorrências',
  '/gestao-orcamentos': 'Gestão de Orçamentos',
  '/pendencia-orcamentos': 'Pendência de Orçamentos',
  '/gestao-ouvidorias': 'Ouvidorias',
  '/gestao-pacientes': 'Cadastros de Pacientes',
  '/gestao-passagens': 'Gestão Passagens',
  '/gestao-previa-recargas': 'Prévia de Recargas',
  '/gestao-remocoes': 'Gestão de Remoções',
  '/gestao-solicitacao-exames': 'Exames',
  '/gestao-visitas-produtividade': 'Visitas × Produtividade',
  '/historico-acessos': 'Histórico de acessos',
  '/home': 'Início',
  '/html-viewer': 'Visualizador HTML',
  '/huddle-homecare': 'Huddle Homecare',
  '/indicador-agenda': 'Indicadores de Agenda',
  '/inep': 'INEP — Ensino',
  '/liberacao-kits': 'Liberação dos Kits',
  '/login': 'Login',
  '/meus-chamados': 'Meus Chamados',
  '/minha-agenda': 'Minha Agenda',
  '/nova-ocorrencia': 'Nova Ocorrência',
  '/nova-senha': 'Nova senha',
  '/obras-direcao': 'Obras Direção',
  '/ocorrencias': 'Ocorrência',
  '/ocorrencias-setores': 'Minhas Ocorrências',
  '/ouvidoria-monitoramento': 'Ouvidoria Monitoramento',
  '/painel-chamados': 'Painel Sustentação',
  '/painel-implantados': 'Painel Implantados',
  '/painel-infeccao': 'Controle de Infecção',
  '/portal-cooperativa': 'Portal Cooperativa',
  '/portal-rh': 'Liberação de Acesso RH',
  '/portal-ti': 'Criação de Acessos IW',
  '/projeto-direcao': 'Projeto Direção',
  '/projeto-homecare': 'Projeto Homecare',
  '/regras-contrato': 'Regras de Contrato',
  '/settings': 'Configurações',
  '/tarefas-qualidade': 'Tarefas da Qualidade',
  '/telefonia-ao-vivo': 'Telefonia ao Vivo',
  '/uploads': 'Uploads',
  '/zaping': 'Zaping',
};

/** '/gestao-captacao?fullscreen=1' → 'Gestão Captação'; '/ocorrencias/123' → 'Ocorrência' */
export function nomeDaTela(caminho) {
  const p = String(caminho || '').split('?')[0];
  if (NOMES_TELAS[p]) return NOMES_TELAS[p];
  const base = '/' + p.split('/').filter(Boolean)[0];
  return NOMES_TELAS[base] || p;
}
